// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__XhOZr","label":"Labeled_label__2qaR3","divider":"Labeled_divider__3UyxM"};